import { createRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/billing/new",
  beforeLoad: ({ context }) => {
    if (context.authLoading) return;
    if (!context.session) throw redirect({ to: "/auth/login" });
  },
  component: lazyRouteComponent(() => import("./billing.new"), "BillingNewPage"),
});
